import { CommonModule, NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { MatIcon } from "@angular/material/icon";
import { GamesStore } from "../../../stores/offers/games.store";
import { AppsStore } from "../../../stores/offers/apps.store";
import { signalState } from "@ngrx/signals";
import { OffersTab } from "../../../models/offers/offer-tab";
import { OfferType } from "@playcharge/common/models/backend/offers/offer-type";
import { ForYouStore } from "../../../stores/offers/for-you.store";
import { OffersTabComponent } from "../offers-tab/offers-tab.component";

@Component({
    selector: "app-offers",
    standalone: true,
    templateUrl: "./offers.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatTabsModule, MatIcon, OffersTabComponent],
})
export class OffersComponent {
    public gamesStore: GamesStore = inject(GamesStore);
    public appsStore: AppsStore = inject(AppsStore);
    public forYouStore: ForYouStore = inject(ForYouStore);

    public tabs = signalState<OffersTab[]>([
        {
            title: "Games",
            icon: "sports_esports",
            offerType: OfferType.Game,
            store: this.gamesStore,
        },
        {
            title: "Apps",
            icon: "apps",
            offerType: OfferType.App,
            store: this.appsStore,
        },
        {
            title: "For You",
            icon: "favorite",
            offerType: OfferType.ForYou,
            store: this.forYouStore,
        },
    ]);
}
